import React from "react";
import ReactTable from "react-table";
import { Card, CardBody, CardTitle } from "reactstrap";
import { mustBeArray } from "../../utils/lib";

const UpcomingRequestsList = ({
  loading,
  collectionList = [],
  deliveryList = [],
}) => {
  const getCollectionColumns = () => {
    return [
      {
        id: "clientName",
        Header: "Client#",
        accessor: (x) => x.clientName,
        maxWidth: 140,
      },
      {
        id: "location",
        Header: "Location",
        accessor: (x) => x.locationName,
      },
      {
        id: "suburb",
        Header: "Suburb",
        accessor: (x) => x.suburb,
        maxWidth: 130,
      },
      {
        id: "tankSize",
        Header: "Tank Size",
        accessor: (x) => x.tankSize,
        maxWidth: 130,
        Cell: (row) =>
           (
            <span>{`${row.original.tankSize}L`}</span> 
          ),
      },
      {
        id: "estimate",
        Header: "Estimate Oil in Tank",
        accessor: (x) => x.estimatedToReach,
        Cell: (row) => (
          <div className="flex justify-content-center ">
            {`${row.original.estimated || 0}%`}
          </div>
        ),
      },
    ];
  };

  const getDeliveryColumns = () => {
    return [
      {
        id: "clientName",
        Header: "Client#",
        accessor: (x) => x.clientName,
        maxWidth: 140,
      },
      {
        id: "location",
        Header: "Location",
        accessor: (x) => x.locationName,
      },
      {
        id: "suburb",
        Header: "Suburb",
        accessor: (x) => x.suburb,
        maxWidth: 130,
      },
      {
        id: "estimate",
        Header: "Estimate",
        accessor: (x) => x.estimatedToReach,
        maxWidth: 130,
        Cell: (row) => (
          <div className="flex justify-content-center ">
            {`${row.original.estimated || 0}%`}
          </div>
        ),
      },
      {
        id: "expected",
        Header: "Expected",
        accessor: (x) => x.tinsExpected,
        align: "center",
        Cell: (row) => (
          <div className="flex justify-content-center ">
            {row.original.tinsExpected} BIBs
          </div>
        ),
      },
    ];
  };
  return (
    <Card className="p-1">
      <CardTitle className="mb-2">Upcoming Requests</CardTitle>
      <CardBody>
        <div>
          <h5>Collection</h5>
          <ReactTable
            sortable
            loading={loading}
            filterable={false}
            showPagination={true}
            defaultPageSize={20}
            data={mustBeArray(collectionList)}
            columns={getCollectionColumns()}
            minRows={
              mustBeArray(collectionList).length === 0
                ? 5
                : mustBeArray(collectionList).length > 20
                ? 20
                : mustBeArray(collectionList).length
            }
            getTrProps={(state, rowInfo, column) => {
              return {
                style: {
                  alignItems: "center",
                },
              };
            }}
          />
        </div>
        <div className="mt-1">
          <h5>Delivery</h5>
          <ReactTable
            sortable
            filterable={false}
            showPagination={true}
            defaultPageSize={20}
            data={mustBeArray(deliveryList)}
            columns={getDeliveryColumns()}
            minRows={
              mustBeArray(deliveryList).length === 0
                ? 5
                : mustBeArray(deliveryList).length > 20
                ? 20
                : mustBeArray(deliveryList).length
            }
            className="selectableRowTable br-1"
            loading={loading}
          />
        </div>
      </CardBody>
    </Card>
  );
};
export default UpcomingRequestsList;
